import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Environmental awareness</div>
                                            <p>Once you have identified which areas need to be developed, you
                                                will need to work with
                                                the individual to decide what to do. Your plan will need to take
                                                into account how much time they
                                                have available, whether any expense will be involved and, if so,
                                                getting this appropriately
                                                sanctioned, beforehand.
                                            </p>
                                            <div className="border_subtitle supLinesapce">Learning styles
                                                consideration
                                            </div>
                                            <p>This requires finding out how the individual prefers to learn.
                                                This is more important than it might
                                                sound – people have different, preferred ways of assimilating
                                                information and getting this wrong
                                                could waste time and money. There are four learning styles<a
                                                    className="superscripttext"
                                                    href="further_info.php?course=300"><sup>4</sup></a> which
                                                suit the majority of people:</p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <ol className="brownbullet-list listcontentSpacing list-bottom-emptypad">

                                                    <li><p><span
                                                        className="subtiltereg ">Activists:</span> people who
                                                        enjoy new experiences and learn best when thrown in at
                                                        the deep end!</p></li>
                                                    <li><p><span className="subtiltereg "> Reflectors: </span>people
                                                        who prefer to listen, review and analyse before making
                                                        decisions.</p></li>
                                                    <li><p><span
                                                        className="subtiltereg "> Pragmatists:</span> those who
                                                        learn best by putting ideas into practice.</p></li>
                                                    <li>
                                                        <div className="uiheading"><p><span
                                                            className="subtiltereg ">Theorists:</span> people
                                                            who synthesise ideas and information through
                                                            exploration.</p></div>
                                                    </li>
                                                </ol>
                                            </div>

                                            <p>If you want to investigate different methods of learning further,
                                                have a look at another of our tools
                                                called ‘How to identify personal learning styles’.</p>


                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">OPTIONS FOR DEVELOPMENT</span>
                                            </div>
                                            <p>The individual may have his or her own ideas about how to achieve
                                                the objectives agreed in your
                                                earlier discussion with them (such as external or online
                                                training). Or you may be able to make
                                                suggestions about strategies which have previously worked for
                                                others. You will also have more
                                                knowledge about what’s going on elsewhere in the workplace which
                                                might be useful (opportunities
                                                to shadow others, perhaps, or to attend meetings and
                                                presentations).</p>
                                            <div className="border_subtitle">Planning action</div>
                                            <p>It’s all very well thinking up a list of great ideas but, unless
                                                they’re written down, they’re unlikely
                                                to happen! Ask the individual to write down what their goals
                                                are, together with their own ideas
                                                about how they might be achieved.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad uiheading greennumberroundbg1 ">
                                                <p> A study showed that the 3% of a surveyed group of graduates
                                                    from Yale University who
                                                    had written goals in 1953 had accumulated more wealth than
                                                    the other 97% altogether
                                                    when asked about their financial position 20 years later.<a
                                                        className="superscripttext supLinesapce"
                                                        href="further_info.php?course=300"><sup>5</sup></a>
                                                </p>
                                            </div>
                                            <div className="border_subtitle">Maintaining momentum</div>
                                            <p>By this stage, the individual should have a written action plan
                                                which, if implemented, will result in
                                                their measurable development. The very fact that it’s all
                                                written down will help them focus!
                                                However, for many, this isn’t enough. People often start with
                                                great intentions – then get distracted
                                                and before they know it, their brilliant plan’s just another
                                                file on the shelf, next to all the others.
                                                (As manager, it’s your job to encourage as well as direct, so,
                                                if you find this is a common problem
                                                amongst your team, there’s another tool to help you, called ‘How
                                                to maintain momentum’). Ways
                                                to keep people focused include linking the stages of their
                                                development to their annual
                                                performance objectives, arranging regular review meetings,
                                                encouraging the individual to allocate regular times in their
                                                diary to focus on development activities, and pointing out that
                                                development
                                                is a gradual, continual process rather than an overnight
                                                revolution. In other words, it’s better to do
                                                a little at a time than a week of feverish activity followed by
                                                months of inertia.</p>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page3')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page5')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </div>;
    }
}